<template>
    <!-- Popup -->
    <van-popup v-model="showPopup" :close-on-click-overlay="false" @click-overlay="$emit('update:showPopup', false)">
        <div :class="['popupWrap', popupObj.isUse && 'popup-bg-small']">
            <div class="popupContent">
                <div class="popupTitleRow center">
                    <img src="@/assets/gameCoin/popup-star-left.webp" />
                    <span :class="['popupTitle', language]">{{ popupObj.popupTitle }}</span>
                    <img src="@/assets/gameCoin/popup-star-right.webp" />
                </div>
                <div class="popupText">
                    <div :class="['popupTextMain', language === 'ug' && 'ug-normal']" v-html="popupObj.sureText"></div>
                    <div :class="['popupTextSub', language]" v-if="!popupObj.isUse">{{ $t('虚拟商品兑换后无法取消兑换。') }}</div>
                </div>
            </div>
            <div class="popupBtns">
                <div :class="['popupBtnCancel', language]" @click="$emit('update:showPopup', false)">{{ popupObj.cancleText
                    }}</div>
                <div :class="['popupBtnConfirm', language]" @click="onConfirmExchange">{{ popupObj.confirmText }}</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    props: {
        showPopup: {
            type: Boolean,
            default: false
        },
        popupObj: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isShow: this.showPopup,
            language: 'ug'
        }
    },
    watch: {
        showPopup(val) {
            this.isShow = val
        }
    },
    methods: {
        onConfirmExchange() {
            this.$emit('confirmExchange')
        }
    },
    created() {
        this.language = this.$route.query.language || 'ug'
    }
}
</script>

<style lang="scss" scoped>
.popupWrap {
    width: 310px;
    background-image: url('../../../assets/gameCoin/popup-bg.webp');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    padding: 20px 15px;
    box-sizing: border-box;

    &::after {
        content: '';
        left: 7px;
        top: 7px;
        width: 19px;
        height: 19px;
        position: absolute;
        @include bg-image-url('~@/assets/gameCoin/popup-firework-left.webp')
    }

    &::before {
        content: '';
        right: 7px;
        top: 7px;
        width: 19px;
        height: 19px;
        position: absolute;
        @include bg-image-url('~@/assets/gameCoin/popup-firework-right.webp')
    }

    .popupContent {
        background: linear-gradient(180deg, #FFFFFF 25%, rgba(255, 255, 255, 0.7) 100%);
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #FFFFFF;
        padding: 20px;
        box-sizing: border-box;

        .popupTitleRow {
            font-weight: 500;
            font-size: 18px;
            color: #181818;
            text-align: center;
            padding-bottom: 20px;

            img {
                width: 13px;
                height: 18px;
            }

            .popupTitle {
                padding: 0 7px;
            }
        }

        .popupText {
            font-size: 14px;
            color: #5C5C5C;
            text-align: center;

            .popupTextSub {
                font-size: 12px;
                color: #999999;
                padding-top: 5px;
                color: #FA5051;
            }
        }
    }

    .popupBtns {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 16px;

        div {
            flex: 1;
            height: 44px;
            line-height: 44px;
            text-align: center;
            background: #FFC936;
            border-radius: 23px;
            font-weight: 500;
            font-size: 16px;
            color: #181818;
        }

        .popupBtnCancel {
            font-weight: 400;
            color: #999999;
            margin-right: 7px;
            background: #F3F4F6;
        }
    }
}
.popup-bg-small {
    background-image: url('../../../assets/gameCoin/popup-bg-small.png') !important;
}

.van-popup {
    background-color: transparent;
}
</style>